// extracted by css-extract-rspack-plugin
export default {"dropdownLoader":"DropdownLoader-module__dropdownLoader"};